/* Reveal an existing product size chart without inventing sizing information. */
function ghostcorpInstallSizeGuide() {
  if (!document.querySelector('main[data-template*="product"]')) return;
  const fieldset = document.querySelector('.variant-option input[data-option-name="Size"], .variant-option input[data-option-name="size"]')?.closest('fieldset');
  if (!fieldset || fieldset.querySelector('.gc-size-guide-link')) return;
  const tables = Array.from(document.querySelectorAll('main[data-template*="product"] .rte table'));
  const sizeTable = tables.find(table => /size|chest|width|length|measurement/i.test(table.textContent || ''));
  if (!sizeTable) return;
  const legend = fieldset.querySelector('legend');
  if (!legend) return;
  const link = document.createElement('button');
  link.type = 'button';
  link.className = 'gc-size-guide-link';
  link.textContent = 'Size guide';
  link.addEventListener('click', () => sizeTable.scrollIntoView({behavior:'smooth',block:'center'}));
  legend.append(link);
}
document.addEventListener('DOMContentLoaded', ghostcorpInstallSizeGuide);
document.addEventListener('shopify:section:load', ghostcorpInstallSizeGuide);
